<template>
  <form id="tripFilterForm" method="post" action="/nl/my-arriva-business/trip/filter" class="filter-datatable"
        @submit.prevent="filter">
    <h3>Zoek op:</h3>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <input-field
          id="tripInvoiceNumber"
          :$v="$v.invoiceNumber"
          :value="invoicenumber"
          :required="false"
          :maxlength="50"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          name="invoicenumber"
          label="Factuurnummer"
          @input="setInvoiceNumber"
        />
      </div>
      <div class="small-12 medium-6 columns">
        <select-field
          id="tripCheckinMonth"
          :$v="$v.checkinMonth"
          :value="checkinMonth"
          :options="checkinMonthOptions"
          :required="false"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          name="tripReplacementStatus"
          label="Maand *"
          @change="setCheckinMonth"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <date-picker-field
          id="checkinDateFrom"
          :value="checkinDateFrom"
          :$v="$v.checkinDateFrom"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          label="Van datum"
          name="checkin-date-from"
          @input="setCheckinDateFrom"
        />
      </div>
      <div class="small-12 medium-6 columns">
        <date-picker-field
          id="checkinDateTo"
          :value="checkinDateTo"
          :$v="$v.checkinDateTo"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          label="tot en met"
          name="checkin-date-to"
          @input="setCheckinDateTo"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <div class="gridelement formsectioncompound">
          <div class="wm-field-label">&nbsp;</div>
          <div class="jq_gridcontentarea">
            <div class="wm-field small-12 columns">
              <div class="wm-field-input">
                <button id="filterSubmit" type="submit" class="confirmation">
                  Zoeken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

import { mapState } from 'vuex'
import InputField from './fields/InputField'
import SelectField from './fields/SelectField'
import DatePickerField from './fields/DatePickerField'
import EngravedId from './fields/EngravedId'
import {
  SET_FILTER_INVOICE_NUMBER,
  SET_FILTER_CHECKIN_MONTH,
  SET_FILTER_CHECKIN_DATE_FROM,
  SET_FILTER_CHECKIN_DATE_TO
} from '../../store/modules/trip/mutation-types'
import { parseStoreDate } from '../../utils/date'

export default {
  name: 'TripFilterForm',
  components: {
    InputField,
    SelectField,
    DatePickerField,
    EngravedId
  },
  computed: {
    ...mapState({
      invoicenumber: state => state.trip.filterInvoiceNumber,
      checkinMonth: state => state.trip.filterCheckinMonth,
      checkinDateFrom: state => parseStoreDate(state.trip.filterCheckinDateFrom),
      checkinDateTo: state => parseStoreDate(state.trip.filterCheckinDateTo)
    }),
    checkinMonthOptions: function () {
      let options = [{value: '', text: 'Selecteer een maand'}]
      if (this.$store.state.trip.filterCheckinMonthOptions === null) {
        return options
      }
      this.$store.state.trip.filterCheckinMonthOptions.forEach((val) => {
        const textualMonth = this.$t(`generic.numericMonths.${val.substring(5, 7)}`)
        const text = `${textualMonth} ${val.substring(0, 4)}`
        options.push({ value: val, text: text })
      })
      return options
    }
  },
  validations () {
    return {
      invoiceNumber: {},
      checkinMonth: {},
      checkinDateFrom: {},
      checkinDateTo: {}
    }
  },
  methods: {
    setInvoiceNumber: function (value) {
      this.$store.commit(`trip/${SET_FILTER_INVOICE_NUMBER}`, value)
    },
    setCheckinMonth: function (value) {
      this.$store.commit(`trip/${SET_FILTER_CHECKIN_MONTH}`, value)
    },
    setCheckinDateFrom: function (value) {
      this.$store.commit(`trip/${SET_FILTER_CHECKIN_DATE_FROM}`, value)
    },
    setCheckinDateTo: function (value) {
      this.$store.commit(`trip/${SET_FILTER_CHECKIN_DATE_TO}`, value)
    },
    filter: function () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/TripFilterForm.vue